$(document).ready(function() {
  // Because European Site doesn't make use of domains or cookies
  // for setting attributes on HTML or currency
  // we're doing some interesting things here with Javascript
  var langifyRef = window.langify;

  if (typeof langifyRef !== 'undefined') {
      var language = langifyRef.helper.getSelectedLanguage();
      var languageMatrix = {
          'ly10848': 'en',
          'ly10852': 'de',
          'ly15355': 'ru'
      }
      var languageCode = languageMatrix[language];
      window.attilusUkLang = languageCode;
      updateHtml(languageCode)

      function updateHtml(lang) {
          $('html').attr('lang', lang);
      }
  }
  
  if ($('.datepicker-wrapper').length > 0) {
    if (window.attilusUkLang === 'de') {
      $('head').append('<script src="//www.attiluscaviar.co.uk/cdn/shop/t/3/assets/datepicker-de.js?v=80937532060870079971641968481" ></script>');
      $('#date').datepicker( $.datepicker.regional[ window.attilusUkLang ] );
    } else if (window.attilusUkLang === 'ru') {
      $('head').append('<script src="//www.attiluscaviar.co.uk/cdn/shop/t/3/assets/datepicker-ru.js?v=81435552092902125671641968406" ></script>');
      $('#date').datepicker( $.datepicker.regional[ window.attilusUkLang ] );
    }
  }



/* begin - Get a Discount Button*/
    var modal_subscription_window = $('#modal-subscription-window');

    if ($('#modal-subscription-window').length) {

        /* #2741 Получение компактной кнопки "Get a Discount" для узких экрунов при загрузке страницы */
        function resizeGetDiscountBnt() {
            var get_discount_btn = $('.get-discount-btn');
            if (window.innerWidth < 1400) {
                if (window.innerWidth > 730) {
                    get_discount_btn.addClass('compact')
                        .hover(
                            function () {
                                $(this).removeClass('compact');
                            },
                            function () {
                                $(this).addClass('compact');
                            });
                } else {
                    get_discount_btn.addClass('compact')
                        .unbind('mouseenter mouseleave');
                }
            } else {
                get_discount_btn.removeClass('compact')
                    .unbind('mouseenter mouseleave');
            }
        }

        // var set_country_code_no_repeat = false;
        var get_discount_btn = $('.get-discount-btn');

        resizeGetDiscountBnt();

        $(window).resize(function () {
            resizeGetDiscountBnt();
        });
        /* */

        //// #2741 - закомментировал страну для UK
        // doRepeat(200, 3000, function() {
        //     var attilus_country_code_by_ip = getCookie('attilus_country_code_by_ip');
        //     if (attilus_country_code_by_ip && !set_country_code_no_repeat) {
        //         modal_subscription_window.find('.country').val(attilus_country_code_by_ip);
        //         set_country_code_no_repeat = true;
        //     }
        // });

        if (!getCookie('modal-subscription-window')) {
            get_discount_btn.show();
        }

        function modalSubscriptionShow() {
            modal_subscription_window.modal({
                fadeDuration: 250,
                fadeDelay: 1.5
            });
        }

        get_discount_btn.click(function () {
            modal_subscription_window.find('.modal_header_get_a_discount').show();
            modal_subscription_window.find('.modal_header_subscribe').hide();
            modal_subscription_window.find('.mc-source').val('discount btn');
            modalSubscriptionShow();
        });

        $('#newsletter-button').click(function () {
            modal_subscription_window.find('.modal_header_get_a_discount').hide();
            modal_subscription_window.find('.modal_header_subscribe').show();
            modal_subscription_window.find('.mc-source').val('newsletter btn');
            modalSubscriptionShow();
        });

    }
/* end - Get a Discount Button*/

/* Intercom chat */

  window.intercomSettings = {
    app_id: "ienfckxa"
  };
  var customerName = "";
  if (customerName.length > 0) {
    window.intercomSettings.name = customerName;
  }
  var customerEmail = "";
  if (customerEmail.length > 0) {
    window.intercomSettings.email = customerEmail;
  }

  (function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',intercomSettings);}else{var d=document;var i=function(){i.c(arguments)};i.q=[];i.c=function(args){i.q.push(args)};w.Intercom=i;function l(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/rt9o9bik';var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);}if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})()

/* End of Intercom chat */

})
